"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatPeriodSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var RepeatPeriodSelect = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatPeriodSelect, _super);
    function RepeatPeriodSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.isInvalidValue = function (value, repeatPeriod) {
            return value === "" || isNaN(repeatPeriod) || repeatPeriod <= 0;
        };
        _this.triggerChangeEvent = function (repeatPeriod) {
            if (_this.state.repeatPeriod !== repeatPeriod) {
                _this.setState({ repeatPeriod: repeatPeriod }, function () { return _this.props.onChange(repeatPeriod); });
            }
        };
        _this.onBlur = function (e) {
            var trimmedValue = e.target.value.trim();
            var repeatPeriod = parseInt(trimmedValue, 10);
            if (_this.isInvalidValue(trimmedValue, repeatPeriod)) {
                _this.setState({ repeatPeriod: _this.props.repeatPeriod || 1 });
                return;
            }
            _this.triggerChangeEvent(repeatPeriod);
        };
        _this.onChange = function (e) {
            var trimmedValue = e.target.value.trim();
            var repeatPeriod = parseInt(trimmedValue, 10);
            if (_this.isInvalidValue(trimmedValue, repeatPeriod)) {
                _this.setState({ repeatPeriod: "" });
                return;
            }
            _this.triggerChangeEvent(repeatPeriod);
        };
        _this.state = {
            repeatPeriod: props.repeatPeriod || 1,
        };
        return _this;
    }
    RepeatPeriodSelect.prototype.render = function () {
        return (React.createElement("div", { className: "gd-schedule-email-dialog-repeat-period" },
            React.createElement("input", { className: "gd-input-field", onBlur: this.onBlur, onChange: this.onChange, value: this.state.repeatPeriod })));
    };
    return RepeatPeriodSelect;
}(React.PureComponent));
exports.RepeatPeriodSelect = RepeatPeriodSelect;
//# sourceMappingURL=RepeatPeriodSelect.js.map